'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import FormattedMessage from 'I18n/components/FormattedMessage';

const isDefined = value => {
  return value !== null && value !== Infinity && value !== undefined && value !== 'Infinity' && !isNaN(value);
};

const CurrencyValue = ({
  value,
  currencySymbol,
  className = ''
}) => /*#__PURE__*/_jsx("span", {
  className: className,
  children: isDefined(value) ? /*#__PURE__*/_jsx(FormattedCurrency, {
    value: value,
    unit: currencySymbol,
    simplifyCurrency: true
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "notApplicableAbbreviation"
  })
});

CurrencyValue.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  // Cost or Spend
  className: PropTypes.string,
  currencySymbol: PropTypes.string.isRequired
};
export default CurrencyValue;